// extracted by mini-css-extract-plugin
module.exports = {"root":"LimitedAccessBanner_root__2NkC-","text":"LimitedAccessBanner_text__3ehud","button":"LimitedAccessBanner_button__2fvRL"};